import { TextField } from "@mui/material"
import { Button, Modal } from "react-bootstrap"
import { Controller, useFormContext } from "react-hook-form"
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { memo, useCallback } from "react";
import ApiAmusementService from "../../../../core/api/api.amusementService";
import Swal from "sweetalert2";



const AddDescriptionModal = ({
  modalNameDate,
  setReserveDescriptions,
  service,
  reserveDescriptions,
  setShowModalAddDescription,
  showModalAddDescription,
  handleModalClose
}) => {
  const methods = useFormContext()

  const handleModalAddDescriptionFormSubmit = useCallback(async (data) => {
    const { description } = data;
    if (description.trim()) {

      setShowModalAddDescription(false);
      let reserveDescriptions2 = reserveDescriptions.filter((desc) => desc.label !== "افزودن توضیح جدید");
      reserveDescriptions2 = reserveDescriptions2.map((desc) => ({
        id: desc.value,
        desc: desc.label,
      }));

      const newId = reserveDescriptions2.length
        ? (parseInt(reserveDescriptions2[reserveDescriptions2.length - 1].id) + 1).toString()
        : "1";

      const newEntry = { id: newId, desc: description };

      reserveDescriptions2 = [...reserveDescriptions2, newEntry];

      const jsonUpdatedDescriptions = JSON.stringify(reserveDescriptions2);

      try {
        const response = await ApiAmusementService.updateAmusementServiceDescription({
          AmusementServiceId: service,
          desc: jsonUpdatedDescriptions,
        });
        if (response.succeeded) {
          Swal.fire({
            title: response.message,
            icon: response.succeeded ? "success" : "error",
            focusCancel: true
          });
          const updatedReserveDescriptions = reserveDescriptions2.map((desc) => ({
            value: desc.id,
            label: desc.desc,
          }));
          setReserveDescriptions(updatedReserveDescriptions);
          methods.setValue(modalNameDate, updatedReserveDescriptions[updatedReserveDescriptions.length - 1]);

        }
      } catch (error) {
      }
    }
  }, [setShowModalAddDescription, modalNameDate, reserveDescriptions, setReserveDescriptions, methods]);

  return (
    <Modal show={showModalAddDescription} onHide={handleModalClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>افزودن توضیح جدید</Modal.Title>
      </Modal.Header>
      <form onSubmit={methods.handleSubmit(handleModalAddDescriptionFormSubmit)}>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="description" className="mt-2">
              توضیح جدید
            </label>
            <Controller
              name="description"
              control={methods.control}
              render={({ field: { onChange, value } }) => (
                <TextField
                  margin="normal"
                  variant="outlined"
                  size="small"
                  value={value}
                  className="mt-1"
                  onInput={onChange}
                  autoFocus={true}
                  placeholder="متن توضیح"
                />
              )}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" className="mr-2">
            <AddIcon />
            افزودن
          </Button>
          <Button variant="danger" onClick={handleModalClose}>
            <CloseIcon />
            بستن
          </Button>
        </Modal.Footer>
      </form>

    </Modal>
  )
}

export default memo(AddDescriptionModal)